import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const

export type tmorCredType = (typeof credentialTypes)[number]
export const tmorDocumentTypes = [
  'invoice',
  'other',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const tmor: CarrierDef<tmorCredType> = {
  name: 'Morneau Transport',
  scac: 'tmor',
  credentialTypes,
  legacyCredMap: [...userPassMap],
  engineLayers: ['documents'],
  documentTypes: tmorDocumentTypes,
}
